import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form'

import language from './language';

function rootReducer() {
  return combineReducers({
    form,
    language: language()
  });
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js